import { render, staticRenderFns } from "./chart_wind.vue?vue&type=template&id=565f39e8&scoped=true"
import script from "./chart_wind.vue?vue&type=script&lang=ts"
export * from "./chart_wind.vue?vue&type=script&lang=ts"
import style0 from "./chart_wind.vue?vue&type=style&index=0&id=565f39e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565f39e8",
  null
  
)

export default component.exports